// packages/ui/src/tools/contributionIcon.ts
import { icons, type LucideIcon } from 'lucide-react';

/**
 * Resolve a tool-contribution `icon` string (a lucide icon name, e.g.
 * `'Terminal'`) to its React component. Tool contributions live in `@slate/core`
 * which is framework-agnostic, so the icon is carried as a name and looked up
 * here in the UI layer. Returns `undefined` for an unknown / absent name so the
 * caller can render without an icon rather than crash.
 */
export function resolveContributionIcon(name: string | undefined): LucideIcon | undefined {
  if (!name) return undefined;
  return (icons as Record<string, LucideIcon>)[name];
}
